export type AiPlanTabKey =
  | "taggingPlan"
  | "enhancedAssessmentPlan";

export type TaggingPlanRow = {
  id: string;
  /** API target_type code (e.g. insight, rtq). */
  objectType: string;
  /** API sub_type code (empty when type has no subtypes, e.g. rtq). */
  objectSubType: string;
  /** Display name from per-tenant types API. */
  objectTypeName: string;
  /** Display name from per-tenant types API (empty when no subtype). */
  objectSubTypeName: string;
  conceptCode: string;
  concept: string;
  values: string;
  description: string;
  enabled: boolean;
  allValues: boolean;
  conceptValues: Array<{
    code: string;
    name: string;
    description: string;
  }>;
};

export const AI_PLAN_PATH = "/plan-and-automation";
export const AI_PLAN_ADD_ITEMS_PATH =
  "/plan-and-automation/add-assessment-plan-items";
export const AI_PLAN_ADD_ENHANCED_TAGGING_RULE_PATH =
  "/plan-and-automation/add-enhanced-tagging-rule";
export const AI_PLAN_EDIT_ENHANCED_TAGGING_RULE_PATH =
  "/plan-and-automation/edit-enhanced-tagging-rule/:ruleId";

export function buildEditEnhancedTaggingRulePath(ruleId: string): string {
  return `/plan-and-automation/edit-enhanced-tagging-rule/${encodeURIComponent(ruleId)}`;
}

/** Sentinel option for selecting all concept values in Tagging Plan forms. */
export const CONCEPT_VALUE_ALL_OPTION = {
  id: "__all__",
  code: "__all__",
  name: "All",
} as const;

export const AI_PLAN_TAB_QUERY_KEY = "tab";

export function isAiPlanTabKey(value: string | null | undefined): value is AiPlanTabKey {
  return value === "taggingPlan" || value === "enhancedAssessmentPlan";
}

export function buildAiPlanPath(tab?: AiPlanTabKey): string {
  if (!tab || tab === "taggingPlan") {
    return AI_PLAN_PATH;
  }
  return `${AI_PLAN_PATH}?${AI_PLAN_TAB_QUERY_KEY}=${tab}`;
}

export const AI_PLAN_TAB_LABELS: Record<
  AiPlanTabKey,
  { line1: string; line2?: string }
> = {
  taggingPlan: { line1: "Tagging Plan" },
  enhancedAssessmentPlan: { line1: "Enhanced Tagging Rule" },
};
